import { render, staticRenderFns } from "./Sudoku.vue?vue&type=template&id=67882d20&scoped=true&"
import script from "./Sudoku.vue?vue&type=script&lang=js&"
export * from "./Sudoku.vue?vue&type=script&lang=js&"
import style0 from "./Sudoku.vue?vue&type=style&index=0&id=67882d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67882d20",
  null
  
)

export default component.exports